import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import "./index.scss";

const UpdatedAtCell = ({ value, row, deleteField }) => {
  const formattedDate = format(new Date(value), "MMMM d, yyyy");
  const history = useHistory();

  return (
    <div data-testid="updated-at" className="updated-at">
      <div className="wrapper">
        <div className="cell-header">Last Updated</div>
        <div>{formattedDate}</div>
      </div>
      <div className="actions">
        <div className="action-icons">
          <div
            data-testid="default-icon-wrapper"
            className={`icons ${row.isExpanded ? "block" : "hidden"}`}
          >
            <span
              className={`icon-eye icon ${row.isExpanded ? "hidden" : ""}`}
              onClick={() =>
                history.push({
                  pathname: `/farms/${row.original.properties.farm_id}`,
                  state: {
                    selectedField: row.original.properties.id,
                    view: true,
                  },
                })
              }
              aria-hidden
            />
            <span
              className="icon-edit icon"
              onClick={() =>
                history.push({
                  pathname: `/farms/${row.original.properties.farm_id}`,
                  state: {
                    selectedField: row.original.properties.id,
                    edit: true,
                  },
                })
              }
              aria-hidden
            />
            <span
              className="icon-trash icon"
              onClick={() => {
                deleteField(row.original.properties);
              }}
              aria-hidden="true"
            />
          </div>
          <span
            data-testid="more-icon"
            className={`icon-more more icon ${
              row.isExpanded ? "hidden" : "block"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

UpdatedAtCell.defaultProps = {};

UpdatedAtCell.propTypes = {
  value: PropTypes.string.isRequired,
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  deleteField: PropTypes.func.isRequired,
};

export default UpdatedAtCell;
